import { client } from './client';

export const getPremises = (postcode, requestConfig) =>
  client('premises', {
    ...requestConfig,
    method: 'GET',
    params: {
      postcode
    }
  });
